const config = {
  apiUrl: import.meta.env.VITE_API_URL,
  isProd: import.meta.env.VITE_IS_PROD,
  name: import.meta.env.VITE_NAME,
  // AI Builder visibility is build-time, per-env. Anything but an explicit
  // "true" hides it (fail-safe off) so it stays dormant in QA/prod until the
  // backend (function + APIM) is live there.
  aiBuilderEnabled: import.meta.env.VITE_AI_BUILDER_ENABLED === 'true',
  // The Runbook Assistant (a separate chat app that signs people in through this portal)
  // is hidden unless this env turns it on: anything but an explicit "true" hides it, and it
  // also needs its address. Build-time, per-env, like aiBuilderEnabled.
  assistantEnabled: import.meta.env.VITE_ASSISTANT_ENABLED === 'true',
  assistantUrl: import.meta.env.VITE_ASSISTANT_URL || '',
  // Trial: a comma-separated list of emails. When set, only these people see the link; leave it
  // empty to show it to every super user / product-team member.
  assistantUsers: (import.meta.env.VITE_ASSISTANT_USERS || '')
    .split(',')
    .map((e) => e.trim().toLowerCase())
    .filter(Boolean),
  mcpAllowedReturnToPrefixes: (() => {
    try {
      return import.meta.env.VITE_MCP_ALLOWED_RETURN_TO_PREFIXES
        ? JSON.parse(import.meta.env.VITE_MCP_ALLOWED_RETURN_TO_PREFIXES)
        : [];
    } catch {
      return [];
    }
  })(),
};

export default config;
